import { FaRegLightbulb, FaPeopleGroup, FaRegHandshake } from "react-icons/fa6";
import { IoCheckmarkOutline } from "react-icons/io5";
import { FaStar } from "react-icons/fa";
import { AiOutlineLike } from "react-icons/ai";
import { LuSettings } from "react-icons/lu";

export const homeData = {
  aboutUs: {
    title: "About Us",
    desc: "A dynamic company committed to supplying engineering efficiency into clients' businesses. They offer a proactive approach to the construction process and a rigid adherence to specifications as paramount to the service it offers.",
  },
  ourWork: {
    title: "Our Work",
    desc: "Our professionals specialize in construction and maintenance projects, delivering high-quality electromechanical solutions across Egypt.",
  },
  ourServices: {
    title: "Our Services",
    desc: "As a contracting company we provide the service of supplying, installing, commissioning and startup of all electromechanical systems through high skilled engineers including but not limited to the following.",
  },
  mainCarousel: [
    {
      id: 1,
      src: "/images/home/c2.jpg",
      alt: "Rakan EG Projects",
      title: "Excellence in Construction",
      description: "Leading electromechanical contracting services across Egypt.",
    },
    {
      id: 2,
      src: "/images/home/hvac home.JPG",
      alt: "HVAC Systems",
      title: "HVAC Excellence",
      description: "Advanced heating, ventilation, and air conditioning systems.",
    },
    {
      id: 3,
      src: "/images/home/elec home.JPG",
      alt: "Electrical Systems",
      title: "Electrical Solutions",
      description: "Comprehensive electrical infrastructure and installations.",
    },
  ],
  workCarousel: [
    {
      id: 1,
      src: "/images/home/hvac.jpg",
      content: "Samsung Warehouses Beni Sweef - HVAC, Plumbing, Infrastructure",
    },
    {
      id: 2,
      src: "/images/home/electrical-systems.jpg",
      content: "Mivida Mall - MEP Systems",
    },
    {
      id: 3,
      src: "/images/home/Light-Current-Systems.jpg",
      content: "Masr Italia Mall - MEP Systems (October & Shorouk)",
    },
    {
      id: 4,
      src: "/images/home/decor home.jpg",
      content: "Trigger Cafe at River Walk - Decoration & MEP",
    },
  ],
  servicesCard: [
    {
      id: 1,
      title: "HVAC",
      description: "Advanced heating, ventilation, and air conditioning systems engineered for energy efficiency, indoor comfort, and climate control precision.",
      imageUrl: "/images/services/hvac_231473096-1024x683.jpg",
      link: "/HVAC",
    },
    {
      id: 2,
      title: "PLUMBING",
      description: "Reliable water supply and drainage systems tailored to meet residential and commercial standards.",
      imageUrl: "/images/services/Plumbing-624x443.png",
      link: "/Plumbing",
    },
    {
      id: 3,
      title: "LIGHT CURRENT",
      description: "Integrated low-voltage systems including data, security, and communication technologies.",
      imageUrl: "/images/services/light current.jpg",
      link: "/LightCurrent",
    },
    {
      id: 4,
      title: "ELECTRICAL",
      description: "Comprehensive electrical infrastructure ensuring safety, functionality, and energy efficiency.",
      imageUrl: "/images/services/electrical.jpeg",
      link: "/Electrical",
    },
    {
      id: 5,
      title: "DECORATION",
      description: "Sophisticated interior finishes that enhance aesthetics and reflect your unique design vision.",
      imageUrl: "/images/services/decoration.jpg",
      link: "/Decoration",
    },
  ],
};

export const navData = [
  { name: "Home", url: "/" },
  { name: "About Us", url: "/about-us" },
  {
    name: "Our Services",
    dropdown: true,
    submenu: [
      { name: "HVAC", url: "/HVAC" },
      { name: "Plumbing", url: "/Plumbing" },
      { name: "Light Current", url: "/LightCurrent" },
      { name: "Electrical", url: "/Electrical" },
      { name: "Decoration", url: "/Decoration" },
    ],
  },
  { name: "Projects", url: "/projects" },
  { name: "Contact Us", url: "/contact-us" },
];

export const aboutUsData = {
  section1: {
    title: "About Us",
    desc: "A dynamic company committed to supplying engineering efficiency into clients' businesses. They offer a proactive approach to the construction process and a rigid adherence to specifications as paramount to the service it offers.",
  },
  section2: {
    title: "Our Vision",
    desc: "The company aims to be well-known as the highest quality contracting service in Egypt. They strive to exceed every expectation to improve standards. The highest standard of life and better quality of life is the core component of their service.",
    cards: [
      { icon: <AiOutlineLike />, title: "Trustworthy" },
      { icon: <FaStar />, title: "Authentic" },
      { icon: <IoCheckmarkOutline />, title: "Reliable" },
      { icon: <FaRegLightbulb />, title: "Value Integrity" },
    ],
  },
};

// src/data.js

export const service1Data = {
  pageHeader: "HVAC Systems",
  section1: {
    title: "Advanced HVAC Solutions for Modern Buildings",
    description: `Rakan EG specializes in advanced heating, ventilation, and air conditioning systems engineered for energy efficiency, indoor comfort, and climate control precision.
    
    Our HVAC department implements comprehensive solutions based on ASHRAE, SMACNA, ARI, ASME, and ASTM standards. We have the capability of implementing heating, ventilation and air conditioning systems for both chilled water and DX systems including VAV, CAV, VRF, CCD, FCU, RTU, Package Units, and more.
    
    We serve various building types including administrative buildings, hotels, industrial facilities, healthcare centers, and commercial spaces. Our team ensures optimal indoor air quality, energy efficiency, and climate control precision for every project.`,
  },
  section2: {
    title: "Our HVAC Expertise",
    cards: [
      {
        index: "1",
        title: "Industry Standards Compliance",
        desc: "All our HVAC installations comply with international standards including ASHRAE, SMACNA, ARI, ASME, and ASTM regulations.",
        icon: <FaRegHandshake />,
      },
      {
        index: "2",
        title: "Advanced System Technologies",
        desc: "We implement cutting-edge HVAC solutions including VAV, CAV, VRF, CCD, FCU, RTU, and Package Units for optimal performance.",
        icon: <FaRegLightbulb />,
      },
      {
        index: "3",
        title: "Energy Efficiency Focus",
        desc: "Our systems are designed for maximum energy efficiency, reducing operational costs while maintaining optimal indoor comfort.",
        icon: <LuSettings />,
      },
      {
        index: "4",
        title: "Versatile Applications",
        desc: "We serve diverse building types including administrative, hotels, industrial, healthcare, and commercial facilities.",
        icon: <FaPeopleGroup />,
      },
    ],
  },
};

export const service2Data = {
  pageHeader: "Electromechanical Services",
  section: {
    title: "Comprehensive Electromechanical Solutions",
    items: [
      {
        image: "/images/services/hvac_231473096-1024x683.jpg",
        alt: "HVAC Systems",
        title: "HVAC Systems",
        description: `Based on the regulations of ASHRAE, SMACNA, ARI, ASME, ASTM standards we have the capability of implementing heating, ventilation and air conditioning systems for both chilled water and DX systems including VAV, CAV, VRF, CCD, FCU, RTU, Package Units, etc. for various building types including admin buildings, hotels, industrial facilities, healthcare centers, and more.`,
      },
      {
        image: "/images/services/electrical.jpeg",
        alt: "Electrical Systems",
        title: "Electrical Systems",
        description: `Electric power works, lighting, earthing, etc. are all covered in our electrical department based on local and international codes like IEC, NEC, NEMA. We give special consideration to safety for both human and equipment by using high quality materials for cables, MCC panels, lighting fixtures. We provide thermal imaging options for all high load MCC panels feeding critical equipment to assure proper installation and operation.`,
      },
      {
        image: "/images/services/light current.jpg",
        alt: "Light Current Systems",
        title: "Light Current Systems",
        description: `Our light current team is specialized in Fire Alarm, Public Address, CCTV, IPTV, MATV and BMS Systems in addition to Access Control & Time Attendance System, Security Gate Systems and Active Switching Equipment. We can convert buildings to smart interactive buildings by adding automatic and remote controls with smart features.`,
      },
      {
        image: "/images/services/Plumbing-624x443.png",
        alt: "Plumbing Systems",
        title: "Plumbing Systems",
        description: `Reliable water supply and drainage systems tailored to meet residential and commercial standards. Our plumbing solutions ensure efficient water distribution, proper drainage, and compliance with all local and international plumbing codes and regulations.`,
      },
      {
        image: "/images/services/decoration.jpg",
        alt: "Decoration Services",
        title: "Interior Decoration",
        description: `Sophisticated interior finishes that enhance aesthetics and reflect your unique design vision. Our decoration services combine functionality with beauty, creating spaces that are both practical and visually appealing for various commercial and residential applications.`,
      },
    ],
  },
};

export const contactData = {
  heading: "Contact Us",
  companyInfoTitle: "Company's info",
  contactDetails: {
    address: "Egypt",
    emails: [
      {
        name: "Mohamed Abu Alsoad",
        emailAddress: "m.abualsoad@rakan-co.com", 
        emailLink: "mailto:m.abualsoad@rakan-co.com",
      },
      {
        name: "Alaa Hazem",
        emailAddress: "a.hazem@rakan-co.com",
        emailLink: "mailto:a.hazem@rakan-co.com",
      },
      
      {
        name: "General Info",
        emailAddress: "info@rakan-co.com",
        emailLink: "mailto:info@rakan-co.com",
      },
    ],
  },
};

export const projectsData = {
  maintenance: {
    title: "Maintenance Projects",
    projects: [
      "Bank Baraka - Fifth Settlement",
      "Bank Baraka - Dumyata", 
      "Bank Baraka - Somouha",
      "Bank Baraka - Miami",
      "Bank Baraka - October",
      "Bank Baraka - Madinti",
      "Bank Operations Center - New Cairo",
      "Bank Ahly Downtown - River Walk Mall",
      "MACAN Cafe",
      "Masr Italia Mall (October + Shorouk)",
      "Mostafa Mahmoud Military Hospital",
    ],
  },
  construction: {
    title: "Construction Projects", 
    projects: [
      {
        name: "PS 1405 Project",
        services: "Decoration & MEP",
      },
      {
        name: "Trigger Cafe (River Walk)",
        services: "Decoration & MEP",
      },
      {
        name: "Mivida Mall",
        services: "MEP Systems",
      },
      {
        name: "Samsung Warehouses - Beni Sweef",
        services: "HVAC, Plumbing, Infrastructure",
      },
      {
        name: "Saray Mall Club House",
        services: "HVAC, Plumbing, Infrastructure",
      },
      {
        name: "Alpha Scan - Mokatam Branch", 
        services: "HVAC Systems",
      },
      {
        name: "Ain Shokna Admin Building",
        services: "Fire Fighting Systems",
      },
      {
        name: "Ashgar City Compound",
        services: "Infrastructure",
      },
      {
        name: "Snacks Factory - 10th of Ramadan",
        services: "Infrastructure",
      },
      {
        name: "Carina Branch - Shorouk",
        services: "HVAC Systems",
      },
      {
        name: "Khamaiel Mall",
        services: "HVAC, Ventilation, Plumbing & Irrigation",
      },
    ],
  },
};
